import React from 'react';

import { isCategoryValid } from '~support-at-home/lib/derive';

import { Row } from '~components/table-view-v3';
import TooltipPortal from '~weekly-planner/components/TooltipPortal';

import { SahCategory, SahServiceTypeAssociation } from '~lookups/models';

interface ComponentProps {
  row: Row;
  serviceTypeAssocs: SahServiceTypeAssociation[];
  categories: SahCategory[];
}

const ReadOnlyCategory: React.FC<ComponentProps> = ({ row, serviceTypeAssocs, categories }) => {
  const categoryValid = isCategoryValid(row, serviceTypeAssocs, categories);
  const category = categories.find((cat) => cat.id === row.category_id);

  if (categoryValid && category) {
    return <div className="p-1">{category.name}</div>;
  } else {
    return (
      <>
        <TooltipPortal targetId={`${row.id}-missing-category`} content="Missing or mismatched category association" />
        <div className="missing-cell" id={`${row.id}-missing-category`}>
          MISSING
        </div>
      </>
    );
  }
};

export default ReadOnlyCategory;
